import { postData, getData } from './ApiSettings';

export const createSwiklyDeposit = async ({
    orderId,
    depositAmount,
    customerEmail,
    firstName,
    lastName,
    startDate,
    endDate
}) => {
    try {
        const response = await postData('/swikly/create-deposit', {
            data: {
                orderId,
                amount: depositAmount,
                customerEmail,
                firstName,
                lastName,
                startDate,
                endDate
            }
        });

        if (!response.data?.data) {
            throw new Error('Invalid response from Swikly service');
        }

        return response.data.data;
    } catch (error) {
        console.error('Error creating Swikly deposit:', error);
        throw new Error(error.response?.data?.message || 'Failed to create deposit request');
    }
};

export const checkSwiklyStatus = async (requestId) => {
    try {
        const response = await getData(`/swikly/check-status/${requestId}`);
        return response.data?.data || { status: 'unknown' };
    } catch (error) {
        console.error('Error checking Swikly status:', error);
        throw error;
    }
};